/** Minimum height for chart area */
export const MIN_CHART_HEIGHT = 406;

/** Gap between short and long bar halves in pixels (2px per Figma) */
export const BAR_GAP = 2;

/** Number of price levels to display on the axis */
export const PRICE_TICK_COUNT = 10;
